<template>
  <employee-table :company-id="companyId" class="mt-3" />
</template>
<script>
import EmployeeTable from '@/components/EmployeeTable.vue';

export default {
  name: 'company_employee_list',
  components: {
    EmployeeTable,
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
  },
  created() {
    this.$store.dispatch('companies/LOAD_DETAIL_DATA');
  },
};
</script>




// WEBPACK FOOTER //
// src/views/pages/admin/companies/detail/Employees.vue